"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractionIcons = exports.IconDivider = exports.CancelAndDivider = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var InteractionIcons = _styledComponents["default"].div.withConfig({
  displayName: "SearchTextInputstyle__InteractionIcons",
  componentId: "sc-6ru1tt-0"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;display:flex;align-items:center;top:0;bottom:0;right:0;", ";.search-input-cancel-container{@keyframes fade-in{0%{opacity:0;}100%{opacity:1;}}@keyframes fade-out{0%{opacity:1;}100%{opacity:0;}}opacity:0;&-enter{animation-name:fade-in;animation-duration:.21s;}&-exit{animation-name:fade-out;animation-duration:.21s;}}"], props.theme.mixins.spacing('margin-right', 3));
});

exports.InteractionIcons = InteractionIcons;

var CancelAndDivider = _styledComponents["default"].div.withConfig({
  displayName: "SearchTextInputstyle__CancelAndDivider",
  componentId: "sc-6ru1tt-1"
})(function () {
  return (0, _styledComponents.css)(["display:flex;"]);
});

exports.CancelAndDivider = CancelAndDivider;

var IconDivider = _styledComponents["default"].div.withConfig({
  displayName: "SearchTextInputstyle__IconDivider",
  componentId: "sc-6ru1tt-2"
})(function (props) {
  return (0, _styledComponents.css)(["", ";border-right:", " ", " ", ";", ";"], props.theme.mixins.responsiveSizing('height', 5), props.theme.border.width[1], props.theme.border.style[1], props.theme.color.monochrome4["default"], props.theme.mixins.advancedSpacing('margin', [0, 3]));
});

exports.IconDivider = IconDivider;
//# sourceMappingURL=SearchTextInput.style.js.map